export default {
  adminToken: 'l4r8x44aeqybmluffpyyxoufxsbjl06w',
  userPhoto: 'https://shop.cvicloud-srv.net/pub/media/customer',
  imgUrl: 'https://shop.cvicloud-srv.net/pub/media/catalog/product/'
}
